module.exports = "<span ng-bind=\"spot.title\"></span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/hot-spot/view.html
// module id = 396
// module chunks = 0